export const MessageTypes = {
  FETCH_ALL: "FETCH_ALL",
  POST_MESSAGE: "POST_MESSAGE",
  NEW_MESSAGE: "NEW_MESSAGE"
}

export const UserTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT"
}

export const ApiTypes = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
  PATCH: "PATCH"
}

export const WHEN = {
  FIRST: "FIRST",
  NORMAL: "NORMAL"
}